import { html } from '@shared/utils/rendering/html';
import { Icon } from '@shared/components/icons';
import { LoaderWithTitle } from '@shared/components/loading';

const LoadingScreen = ({ details }) => {
    return html`<div class="loading-screen">
        <div class="loading-screen__content">
            ${
                details?.icon
                    ? html`<div class="loading-screen__icon">
                          <${Icon} name=${details.icon} />
                      </div>`
                    : null
            }
            <div class="loading-screen__loader">
                <${LoaderWithTitle}
                    busyLoading=${true}
                    title="Loading ${details?.title || 'Application'}"
                />
            </div>
        </div>
    </div>`;
};

export default LoadingScreen;
